import { CmtsEnterpriseForm, type CmtsFormField } from "../forms/index.js";
import type { DropdownOption } from "../../types/api.types.js";
import { buildVerificationCreatePayload, type VerificationCreatePayload } from "../../core/payloads/cmtsTypedPayloads.js";

function toOptions(options?: readonly DropdownOption[]) {
  return (options ?? []).filter((item) => item.isActive !== false).map((item) => ({ value: item.value, label: item.label }));
}

export type CmtsVerificationFormProps = {
  readonly complaintId: string;
  readonly pendingStatusId: string;
  readonly verificationRules: readonly DropdownOption[];
  readonly permittedVerifiers: readonly DropdownOption[];
  readonly busy?: boolean | undefined;
  readonly error?: string | null | undefined;
  readonly onSubmit: (payload: VerificationCreatePayload) => void | Promise<void>;
};

export function CmtsVerificationForm({ complaintId, pendingStatusId, verificationRules, permittedVerifiers, busy, error, onSubmit }: CmtsVerificationFormProps) {
  const fields: readonly CmtsFormField[] = [
    { name: "verificationRuleId", label: "Verification rule", type: "select", required: true, options: toOptions(verificationRules) },
    { name: "verifierUserId", label: "Permitted verifier", type: "select", required: true, options: toOptions(permittedVerifiers) },
  ];

  return (
    <CmtsEnterpriseForm
      fields={fields}
      initialValues={{ complaintId, pendingStatusId }}
      submitLabel="Create verification"
      busy={busy}
      error={error}
      onSubmit={(payload) => onSubmit(buildVerificationCreatePayload(payload))}
    />
  );
}
